import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { AuthForgotPssDialogComponent } from './auth-forgot-pss-dialog/auth-forgot-pss-dialog.component';
import { AuthForgotPssConfirmDialogComponent } from './auth-forgot-pss-confirm-dialog/auth-forgot-pss-confirm-dialog.component';

@NgModule({
  declarations: [
    AuthForgotPssDialogComponent,
    AuthForgotPssConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  exports: [AuthForgotPssDialogComponent, AuthForgotPssConfirmDialogComponent],
})
export class AuthForgotPssModule {}
